var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_vm.isObserver)?_c('div',[_c('div',{staticClass:"initials",style:(_vm.styleString),domProps:{"innerHTML":_vm._s(_vm.initials)}})]):_c('div',{staticClass:"observer-img"},[_c('img',{attrs:{"src":require("@/assets/images/logos/Crucial-C.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }